import { Order } from '@ml/orders/types/order';
import { User } from '@ml/core/types/classes/user.class';
import { Customer } from '@ml/customers/types/customer';
import { TaskStatus } from '@ml/tasks/types/enums/task-status.enum';
import { TaskLog } from '@ml/tasks/types/classes/task-log.class';
import { MeasurementUnit, Service, Unit } from '@ml/services/types/service';
import { Machine } from '@ml/machineries/types/machine';
import { Attachment } from '@ml/machineries/types/attachment';
import { TaskInformation } from '@ml/tasks/types/classes/task-information.class';
import { TaskBilling } from '@ml/tasks/types/classes/task-billing.class';
import { TaskSchedule } from '@ml/tasks/types/classes/task-schedule.class';
import { TaskLocation } from '@ml/tasks/types/classes/task-location.class';

export class Task {
  id?: number;
  created?: string | Date;

  billable?: boolean;
  status: TaskStatus;
  logs: TaskLog[];

  /**
   * If the task was paid
   */
  paid: boolean;

  commented?: boolean;

  /**
   *  Information details
   */
  service: Service | number;
  servicePosition?: number;
  name: string;
  description?: string;
  driverDescription?: string;

  order?: Order | number;
  customer?: Customer | number;

  /**
   * Billing Details
   */
  measurementUnits: MeasurementUnit[];
  hourlyRate: number;

  /**
   * Schedule
   */
  employee: User | number;
  updateEmployeeOnWorklogItems: boolean;
  machine: Machine | number;
  attachments: Attachment[] | number[];
  locations: TaskLocation[] | number[];

  date: string | Date;
  time: string;

  position: number;
  /**
   * Used for straw service
   */
  diameter?: number;

  readonly fullName?: string;

  readonly good?: boolean;

  constructor(task?: Task) {
    if (task) {
      Object.assign(this, task);
    }
  }

  set information(taskInformation: TaskInformation) {
    this.name = taskInformation.name;
    this.description = taskInformation.description;
    this.driverDescription = taskInformation.driverDescription;
    this.service = taskInformation.service;
    this.order = taskInformation.order;
    this.customer = taskInformation.customer;
    this.measurementUnits = taskInformation.measurementUnits;
    this.hourlyRate = taskInformation.hourlyRate;
    this.diameter = taskInformation.diameter;
  }

  set billingDetails(billing: TaskBilling) {
    this.measurementUnits = billing.measurementUnits;
    this.hourlyRate = billing.hourlyRate;
  }

  set schedule(schedule: TaskSchedule) {
    this.employee = schedule.employee;
    this.updateEmployeeOnWorklogItems = schedule.updateEmployeeOnWorklogItems;
    this.machine = schedule.machine;
    this.attachments = schedule.attachments;
    this.date = schedule.date;
    this.time = schedule.time;
  }
}
